import { StatusCodes } from 'http-status-codes';
import { EditableEntity, IPropEventBroker } from '@zdrbm/zdr-native-tools';
import { ISessionValidatorService } from './ISessionValidatorService';
import { IHttpClient } from '..';

const ONE_MINUTE = 60 * 1000;

export class SessionValidatorService
    extends EditableEntity<keyof ISessionValidatorService>
    implements ISessionValidatorService
{
    private intervalId: ReturnType<typeof setInterval> | null = null;
    isSessionValid: IPropEventBroker<boolean>;

    constructor(private client: IHttpClient) {
        super(undefined);
        this.isSessionValid = this.createPropEventBroker('isSessionValid', true);
    }

    private clearInterval(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    private async validateSessionApi(): Promise<boolean> {
        try {
            await this.client.get('/verify-session');
            return true;
        } catch (error: any) {
            if (error.status === StatusCodes.UNAUTHORIZED) {
                return false;
            }
            console.error('Session validation failed:', error);
            return true;
        }
    }

    private async validateSession(): Promise<void> {
        // Validate the current user session token
        const isValid = await this.validateSessionApi();
        this.isSessionValid.set(isValid);
    }

    startSessionValidation(): void {
        this.clearInterval();

        this.isSessionValid.set(true);

        this.validateSession();

        // Set up interval with explicit binding
        this.intervalId = setInterval(this.validateSession.bind(this), ONE_MINUTE);
    }

    stopSessionValidation(): void {
        this.clearInterval();
    }

    getEntityName(): string {
        return 'SessionValidatorService';
    }
}
